module.exports = __webpack_public_path__ + "175a934d2aa02b566fb3ac90344a57e9.svg";